import {AditionProvider} from '@travel-frontend/ui-components';
import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router';

import {config} from '@/config';
import {PAGE_OFFERS} from '@/consts';
import {useAditionProfileParams} from '@/modules/common/components/Adition';
import {AppPromotionLayer} from '@/modules/common/components/AppPromotionLayer';
import {ExitIntentLayer} from '@/modules/common/components/ExitIntentLayer';
import {FilterOverlayProvider} from '@/modules/common/context/FilterOverlay';
import {SeaCampaignProvider} from '@/modules/common/context/SeaCampaign';
import {SearchFormOverlayProvider} from '@/modules/common/context/SearchFormOverlay';
import {useLocalSplit} from '@/modules/common/hooks';
import {CampaignsProvider} from '@/modules/common/hooks/useCampaigns';
import {Layout} from '@/modules/hotels/components/Layout';
import {useAppSelector} from '@/redux/config';
import {
  getMetaFiltered,
  getMetaUnfiltered,
} from '@/redux/v1/hotels/list/reducer';

const HotelsPage = () => {
  const location = useLocation();

  const aditionProfileParams = useAditionProfileParams();

  const hotelsAditionAdsEnabled =
    useLocalSplit('FFP_3943_hotels_adition_ads').treatment === 'on' &&
    aditionProfileParams !== null;

  const scrollToTopOnMount =
    location?.state?.forceReload === true &&
    location.state?.referrer === PAGE_OFFERS;

  // @TODO use <ScrollRestoration /> from react-router instead
  useLayoutEffect(() => {
    if (scrollToTopOnMount) {
      window.scrollTo(0, 0);
    }
  }, [scrollToTopOnMount]);

  const metaUnfiltered = useAppSelector(getMetaUnfiltered);
  const metaFiltered = useAppSelector(getMetaFiltered);

  return (
    <SearchFormOverlayProvider>
      <FilterOverlayProvider>
        <SeaCampaignProvider>
          <AppPromotionLayer />
          <AditionProvider
            enabled={hotelsAditionAdsEnabled}
            slots={config.adition.slots}
            profiles={aditionProfileParams}
          >
            <CampaignsProvider
              metaFiltered={metaFiltered}
              metaUnfiltered={metaUnfiltered}
            >
              <Layout />
              <ExitIntentLayer />
            </CampaignsProvider>
          </AditionProvider>
        </SeaCampaignProvider>
      </FilterOverlayProvider>
    </SearchFormOverlayProvider>
  );
};

export default HotelsPage;
